module.exports = __webpack_public_path__ + "img/ger_242_btn1.faf6a5ea.png";